export const validPlayerDataQuery = {
  bool: {
    must: [
      { exists: { field: 'sportsData.participant.participantId' } },
      { term: { 'sportsData.participant.type': 'PLAYER' } },
    ],
  },
};
